import { AuthorizationNotifier, AuthorizationRequest, AuthorizationServiceConfiguration, BaseTokenRequestHandler, DefaultCrypto, FetchRequestor, LocalStorageBackend, RedirectRequestHandler, TokenRequest, GRANT_TYPE_AUTHORIZATION_CODE, GRANT_TYPE_REFRESH_TOKEN, BasicQueryStringUtils } from '@openid/appauth';
import Axios from 'axios';

class AuthorizationServiceContainer {

    configuration = null;

    constructor() {
        this.notifier = new AuthorizationNotifier();
        this.authorizationHandler = new RedirectRequestHandler(new LocalStorageBackend(), new NoHashQueryStringUtils(), window.location, new DefaultCrypto());
        this.tokenHandler = new BaseTokenRequestHandler(new FetchRequestor(), new NoHashQueryStringUtils());
        this.authorizationHandler.setAuthorizationNotifier(this.notifier);    
        this.notifier.setAuthorizationListener((request, response, error) => {
            console.log('Authorization request complete ', request, response, error);
            this.code = response.code;
            this.request = request;
        });
    }

    async authorize(issuer, clientId, redirectUri, scopes) {
        this.configuration = this.configuration ?? await AuthorizationServiceConfiguration.fetchFromIssuer(issuer, new FetchRequestor());

        let authorizationRequest = new AuthorizationRequest({
            client_id: clientId,
            redirect_uri: redirectUri,
            scope: scopes,
            response_type: AuthorizationRequest.RESPONSE_TYPE_CODE
        });

        this.authorizationHandler.performAuthorizationRequest(this.configuration, authorizationRequest);
    }

    async retrieveToken(issuer, clientId, redirectUri) {
        this.configuration = this.configuration ?? await AuthorizationServiceConfiguration.fetchFromIssuer(issuer, new FetchRequestor());
        let extras = null;
        if (this.request && this.request.internal) {
            extras = {};
            extras['code_verifier'] = this.request.internal['code_verifier'];
        }
        this.request = new TokenRequest({
            client_id: clientId,
            redirect_uri: redirectUri,
            grant_type: GRANT_TYPE_AUTHORIZATION_CODE,
            code: this.code,
            extras: extras,
        });

        return this.tokenHandler.performTokenRequest(this.configuration, this.request);
    }

    async refreshToken(issuer, clientId, redirectUri, refreshToken) {
        this.configuration = this.configuration ?? await AuthorizationServiceConfiguration.fetchFromIssuer(issuer, new FetchRequestor());
        let request = new TokenRequest({
            client_id: clientId,
            redirect_uri: redirectUri,
            grant_type: GRANT_TYPE_REFRESH_TOKEN,
            refresh_token: refreshToken
          });
        
          return this.tokenHandler.performTokenRequest(this.configuration, request);
    }

    async revokeToken(issuer, token) {
        window.location = `${issuer}/identity/account/logout/?post_logout_redirect_uri=${process.env.REACT_APP_OIDC_REDIRECT_URL}`;
    }
}

class NoHashQueryStringUtils extends BasicQueryStringUtils {
    parse(input, useHash) {
        return super.parse(input, false /* never use hash */);
    }
}

const instance = new AuthorizationServiceContainer();

async function authorize({
    issuer,
    clientId,
    redirectUri,
    scopes
}) {
    if (!instance) {
        return Promise.reject("No authentication service configured.");
    }

    await instance.authorizationHandler.completeAuthorizationRequestIfPossible();
    
    if (instance.code) {
        return instance.retrieveToken(issuer, clientId, redirectUri);
    } else {
        instance.authorize(issuer, clientId, redirectUri, scopes);
    }
}

async function refresh({
    issuer,
    clientId,
    redirectUri
}, 
refreshToken) {
    if (!instance) {
        return Promise.reject("No authentication service configured.");
    }
    
    return instance.refreshToken(issuer, clientId, redirectUri, refreshToken);
}

async function revoke({
    issuer
},
    token) {
    console.log(token);

    if (!instance) {
        return Promise.reject("No authentication service configured.");
    }

    return instance.revokeToken(issuer, token);
}

function getUserinfo({
    issuer
}) {
    return Axios.get(`${issuer}/connect/userinfo`);
}

function getUserProfile(id) {
    return Axios.get(`${process.env.REACT_APP_API}/user/${id}`);
}

export  {
    authorize,
    refresh,
    revoke,
    getUserinfo,
    getUserProfile
}